var e = [];
export {
  e as resizeObservers
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/utils/resizeObservers.js
// module id = 246
// module chunks = 67